
import customAxios from "config";
import { globalJson } from "global/global_json";
import { renterError } from "utils/errorMessage";

export const getRentalAgreementContent = async (
  path: string
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.get(
      `/api/company/get-booking-pdf-data/${path}/`
    );
    return response.data; // Return response data if successful
  } catch (error) {
    return { error: renterError(error, "agreement") };
  }
};

export const getPrivacyPolicyContent = async (): Promise<any> => {
  try {
    const response = await customAxios.get("/api/company/content/", {
      params: { company_id: globalJson.company_id }, // Send company_id as query parameter
    });
    return { data: response.data }; // Explicitly return data in expected format
  } catch (error) {
    return { error: renterError(error, "agreement") };
  }
};

export async function sendRentalAgreement(salt_key: any, type: string) {
  try {
    const response = await customAxios.get(
      `/api/company/resend-email/${salt_key}/${type}/`
    );
    return response.data; // Return response data if successful
  } catch (error) {
    return { error: renterError(error, "agreement") };
  }
}